module.exports = __webpack_public_path__ + "static/media/04_tn.124f54a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/04_tn.jpg
// module id = 142
// module chunks = 0